 export default {
   beforeEnter (el, location) {
     // console.log('before Enter')
     var windowWidth = screen.width
     var pageName = location
     // alert(pageName)
     var profile = document.getElementsByClassName('profile')
     var flockInner = document.getElementById('flock')
     var projectHeader = document.getElementById('projHeader')
     // var headerText = document.getElementById('text')
     // var servicesPage = document.getElementById('services')
     // var service = document.getElementById('service')

     if (pageName === 'Profile') {
       if (windowWidth > 1024) {
         profile[0].style.right = '-50vw'
         profile[0].style.zIndex = '-1'
         profile[0].style.position = 'absolute'
         document.getElementById('goBack').style.opacity = 0
         profile[0].style.backgroundColour = '#EFF0F1'
       } else {
         document.body.style.backgroundColour = '#EFF0F1'
         profile[0].style.right = '-100vw'
         profile[0].style.zIndex = '-1'
         profile[0].style.position = 'absolute'
         // profile[0].style.top = '0'
         document.getElementById('goBack').style.opacity = 0
       }
     } else if (pageName === 'Service') {
       if (windowWidth > 1024) {
         el.style.position = 'absolute'
         el.style.top = 0
         el.style.right = '-100vw'
         el.style.width = '100vw'
       } else {
         el.style.position = 'absolute'
         el.style.top = 0
         el.style.right = '-100vw'
         el.style.width = '100vw'
       }
     } else if (pageName === 'theFlock') {
       document.documentElement.style.overflowX = 'hidden'
       document.getElementById('wrap').style.backgroundColour = '#141719'
       profile = profile[0]
       if (!profile) {
         el.style.zIndex = '-1'
         flockInner.style.opacity = '0'
         document.getElementById('instagramFeed').style.right = '-50vw'
         // document.getElementById('instagramFeed').style.opacity = 0
       }
       if (profile) {
         document.documentElement.style.overflowX = 'hidden'
         // flockInner.style.marginTop = '0'
         document.getElementById('instagramFeed').style.right = '-50vw'
         // document.getElementById('instagramFeed').style.opacity = 0
         if (windowWidth > 1024) {
           flockInner.style.opacity = '1'
           el.style.right = '43vw'
         } else {
           flockInner.style.opacity = '1'
           el.style.right = '100vw'
         } // el.style.width = 'auto'
       }
       // window.scrollTo(0, 0)
     } else if (pageName === 'Project') {
       var fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 1')
         projectHeader.style.height = '100vh'
         // headerText.style.bottom = '10vh'
         el.style.position = 'absolute'
         el.style.zIndex = '-1'
         el.style.height = '100vh'
         el.style.overflow = 'hidden'
       } else {
         // console.log('-------->>> not coming from HOME')
         // headerText.style.bottom = '10vh'
         el.style.position = 'absolute'
         el.style.zIndex = '-1'
         // el.style.opacity = 0
       }
       el.style.width = '100%'
     } else if (pageName === 'Work') {
       fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 1')
         projectHeader.style.height = '100vh'
         // headerText.style.bottom = '10vh'
         el.style.position = 'absolute'
         el.style.zIndex = '-1'
         el.style.height = '100vh'
         el.style.overflow = 'hidden'
       } else {
         // console.log('-------->>> not coming from HOME')
         // headerText.style.bottom = '10vh'
         el.style.position = 'absolute'
         el.style.zIndex = '-1'
         // el.style.opacity = 0
       }
       el.style.width = '100%'
     } else if (pageName === 'Home') {
       var homeInner = document.getElementById('innerNutshell')
       // homeInner.style.marginTop = '-10vh'
       homeInner.style.opacity = '1'
     } else if (pageName === 'nutshell') {
       var innerNutshell = document.getElementById('casestudiesInner')
       innerNutshell.style.marginTop = '20vh'
       innerNutshell.style.opacity = '0'
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       var innerServices = document.getElementById('services')
       // innerServices.style.marginTop = '20vh'
       innerServices.style.opacity = '0'
     } else if (pageName === 'casestudies') {
       el.style.opacity = 0
       // var innerCasestudies = document.getElementById('innerNutshell')
       // innerCasestudies.style.opacity = '0'
     } else {
       el.style.opacity = 0
       el.style.marginTop = '20vh'
     }
   },
   enter (el, location, done) {
     // console.log('Enter ' + location)
     var windowWidth = screen.width
     var profile = document.getElementsByClassName('profile')
     profile = profile[0]
     var pageName = location
     var hideBack = document.getElementById('goBack')
     var flockInner = document.getElementById('flock')
     var servicesInner = document.getElementById('services')
     var projectContent = document.getElementById('projectContent')
     // var innerCasestudies = document.getElementById('innerNutshell')
     var projectHeader = document.getElementById('projHeader')
     // var headerText = document.getElementById('text')
     var homeInner = document.getElementById('innerNutshell')
     // var service = document.getElementById('service')
     // var nutshellInner = document.getElementById('casestudiesInner')
     var menuBar = document.getElementById('menuBar')

     if (pageName === 'Profile') {
       if (windowWidth > 1024) {
         // window.Velocity(profile, { zIndex: 1 }, { duration: 1, delay: 100 })
         window.Velocity(profile, { right: 0 }, { duration: 760 })
         window.Velocity(menuBar, { opacity: 1 }, { duartion: 200 })
         window.Velocity(hideBack, { opacity: 1 }, { duration: 400, delay: 2000, complete: done })
       } else {
         window.Velocity(document.body, 'scroll', { offset: 0 }, { duration: 4000 })
         window.Velocity(profile, { right: 0 }, { duration: 760 })
         // window.Velocity(menuBar, { opacity: 1 }, { duartion: 900 })
         window.Velocity(hideBack, { opacity: 1 }, { duration: 400, delay: 2000, complete: done })
       }
     } else if (pageName === 'Service') {
       window.Velocity(el, { right: 0 }, { duartion: 800,
         delay: 400,
         complete: function () {
           window.scrollTo(0, 0)
         }
       })
     } else if (pageName === 'theFlock') {
       document.getElementById('wrap').style.backgroundColour = '#EFF0F1'
       if (profile) {
         // window.scrollTo(0, 0)
         // window.Velocity(flockInner, { opacity: 1 }, { duration: 1500, delay: 400, complete: done })
         window.Velocity(el, { right: 0 }, { duration: 768, complete: done })
       } else {
         window.Velocity(flockInner, { opacity: 1 }, { duration: 800, delay: 1500, complete: done })
       }
     } else if (pageName === 'Project') {
       var fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 2')
         window.Velocity(projectContent, { marginTop: '0px' }, { duration: 1500 })
         // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
         window.Velocity(projectHeader, { height: '75vh' }, { duration: 1500, complete: done })
       } else {
         // console.log('-------->>> not coming from HOME')
         var projectFooter = document.getElementById('casestudyFooter')
         window.scrollTo(0, 0)
         if (projectFooter) {
           // console.log('this.........')
           // ----> window.scrollTo(0, 0)
           if (windowWidth >= 1024) {
             // window.Velocity(headerText, { bottom: '35vh' }, { duration: 1500 })
           } else {
             // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
           }
         } else {
           // console.log('that')
           window.Velocity(projectContent, { marginTop: '0px' }, { duration: 1500 })
           if (windowWidth >= 1024) {
             // window.Velocity(headerText, { bottom: '35vh' }, { duration: 1500 })
           } else {
             // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
           }
           window.Velocity(projectHeader, { height: '75vh' }, { duration: 1500, complete: done })
         }
       }
     } else if (pageName === 'Work') {
       fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 2')
         window.Velocity(projectContent, { marginTop: '0px' }, { duration: 1500 })
         // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
         window.Velocity(projectHeader, { height: '75vh' }, { duration: 1500, complete: done })
       } else {
         // console.log('-------->>> not coming from HOME')
         // var projectFooter = document.getElementById('casestudyFooter')
         if (projectFooter) {
           // console.log('this.........')
           // ----> window.scrollTo(0, 0)
           if (windowWidth >= 1024) {
             // window.Velocity(headerText, { bottom: '35vh' }, { duration: 1500 })
           } else {
             // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
           }
         } else {
           // console.log('that')
           window.Velocity(projectContent, { marginTop: '0px' }, { duration: 1500 })
           if (windowWidth >= 1024) {
             // window.Velocity(headerText, { bottom: '35vh' }, { duration: 1500 })
           } else {
             // window.Velocity(headerText, { bottom: '10vh' }, { duration: 1500 })
           }
           window.Velocity(projectHeader, { height: '75vh' }, { duration: 1500, complete: done })
         }
       }
     } else if (pageName === 'Home') {
       window.scrollTo(0, 0)
       document.getElementById('scrollDown').classList.add('fadeMeIn')
       // console.log('entering home')
       window.Velocity(homeInner, { opacity: 1, marginTop: 0 }, { duration: 800, delay: 3800, complete: done })

       // homeInner.getElementsByClassName('txtWhite').style.opacity = 1
     } else if (pageName === 'casestudies') {
       // console.log('this step loads content')
       window.Velocity(el, { opacity: 1 }, { duration: 800, delay: 800, complete: done })
       /* if (windowWidth > 1024) {
         window.Velocity(el, { opacity: 1, marginTop: 0 }, { duration: 800, complete: done })
       } else {
         window.Velocity(el, { opacity: 1, marginTop: 0 }, { duration: 800, complete: done })
       } */
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       console.log('step1')
      /* window.Velocity(document.body, 'scroll', { offset: 0 }, { duration: 200, delay: 3000 }) */
       window.Velocity(servicesInner, { opacity: 1 }, { duration: 800,
         delay: 1800,
         complete: function () {
           document.getElementById('intro').classList.add('fadeMeIn')
           document.getElementById('flockList').classList.add('fadeMeIn')
           document.getElementById('scrollDown').classList.add('fadeMeIn')
         }
       })
     } else {
       window.Velociity(el, { opacity: 1, marginTop: 0 }, { duartion: 800, delay: 800, complete: done })
     }
   },
   afterEnter (el, location, done) {
     // console.log('after Enter')
     // var windowWidth = screen.width
     var pageName = location
     // var mobileGoBack = document.getElementById('goBackv2')

     if (pageName === 'theFlock') {
       el.style.zIndex = 0
       el.style.position = 'relative'
       el.style.width = 'auto'
       var instagramFeed = document.getElementById('instagramFeed')
       window.Velocity(instagramFeed, { right: 0 }, { duration: 500, delay: 1500, easing: [ 0.42, 0, 1, 1 ] })
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       el.style.zIndex = 1
       el.style.position = 'relative'
       el.style.width = 'auto'
     } else if (pageName === 'casestudies') {
       el.style.zIndex = 0
       el.style.position = 'relative'
       el.style.width = 'auto'
     } else if (pageName === 'Project') {
       el.style.position = 'relative'
       el.style.zIndex = '1'
       el.style.height = 'auto'
       el.style.overflowY = 'visible'
     } else if (pageName === 'Work') {
       el.style.position = 'relative'
       el.style.zIndex = '1'
       el.style.height = 'auto'
       el.style.overflowY = 'visible'
     } else if (pageName === 'Profile' || pageName === 'Service') {
       // if (windowWidth > 1024) {
       el.style.position = 'relative'
       el.style.zIndex = '1'
     } else if (pageName === 'Home') {
       var cta = document.getElementById('cta')
       window.Velocity(cta, { opacity: 1 }, { duration: 800, delay: 500 })
      /* } else {
        // el.style.position = 'relative'
        window.Velocity(mobileGoBack, { opacity: 1 }, { duration: 500 })
      } */
     }
   },
   beforeLeave (el, location) {
     // console.log('before Leave')
     var windowWidth = screen.width
     var pageName = location
     var profile = document.getElementsByClassName('profile')
     var flock = document.getElementsByClassName('flock')
     // var hideBack = document.getElementById('goBack')
     var curtain = document.getElementById('curtain')
     // var previewImage = document.getElementById('previewImages')
     var instragramView = document.getElementById('instagramFeed')
     var slide = document.getElementsByClassName('VueCarousel-slide-active')
     var servicesWrap = document.getElementsByClassName('services')
     // var service = document.getElementById('service')
     // service = service.parentNode
     // var menuBar = document.getElementById('menuBar')

     if (pageName === 'theFlock') {
       profile = profile[0]
       flock = flock[0]
       if (profile) { // if you're on the profile page and heading back to the flock page
         profile.style.position = 'absolute'
         profile.style.zIndex = '1'
         // menuBar.style.opacity = '0'

         // if (windowWidth > 1024) {
         flock.style.zIndex = '-1'
         if (windowWidth > 1024) {
           flock.style.height = '100vh'
         } else {
           flock.style.height = '75hvh'
         }
        /* } else {
          hideBack.style.opacity = '0'
          flock.style.zIndex = '-1'
          document.getElementById('profileImage').style.height = '90vh'
        } */
        // window.Velocity(hideBack, { opacity: '0' }, { duration: 200 })
       }
       curtain.style.height = '0px'
       curtain.style.top = '0'
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       curtain.style.height = '0px'
       curtain.style.top = '0'
     } else if (pageName === 'Home') {
       curtain.style.height = '0px'
       curtain.style.top = '0'
     } else if (pageName === 'casestudies') {
       curtain.style.height = '0px'
       curtain.style.top = '0'
       curtain.style.zIndex = '6'
     } else if (pageName === 'Home') {
       curtain.style.height = '0px'
       curtain.style.top = '0'
       /* slide = slide[0]
       if (slide) {
         window.Velocity(slide, { position: 'absolute', zIndex: '1' }, { duration: 1 })
         window.Velocity(slide, { height: '100vh' }, { duration: 150 })
       } */
     } else if (pageName === 'Project') {
       var fromHome = document.getElementsByClassName('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 3')
         slide = slide[0]
         if (slide) {
           window.Velocity(slide, { height: '100vh' }, { duration: 150 })
         } else {
           var firstSlide = document.getElementById('slide0')
           window.Velocity(firstSlide, { height: '100vh' }, { duration: 150 })
         }
         // window.Velocity(slide, { position: 'absolute', zIndex: '1' }, { duration: 1 })
       } else {
         var projectFooter = document.getElementById('casestudyFooter')
         if (projectFooter) {
          // window.Velocity(el, { top: '-50vh' }, { duration: 800 })
           curtain.style.height = '100vh'
           curtain.style.top = '100vh'
          // curtain.style.position = 'absolute'
           curtain.style.zIndex = '5'
         } else {
           curtain.style.height = '0px'
           curtain.style.top = '0'
           curtain.style.position = 'absolute'
           curtain.style.zIndex = '5'
         }
       }
      // window.Velocity(el, { zIndex: '-1' }, { duration: 10 })
      // slide.style.height = '100vh'
      // slide.style.position = 'absolute'
      // slide.style.zIndex = '0'
     } else if (pageName === 'Work') {
       fromHome = document.getElementsByClassName('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 3')
         slide = slide[0]
         if (slide) {
           window.Velocity(slide, { height: '100vh' }, { duration: 150 })
         } else {
           firstSlide = document.getElementById('slide0')
           window.Velocity(firstSlide, { height: '100vh' }, { duration: 150 })
         }
         // window.Velocity(slide, { position: 'absolute', zIndex: '1' }, { duration: 1 })
       } else {
         projectFooter = document.getElementById('casestudyFooter')
         if (projectFooter) {
          // window.Velocity(el, { top: '-50vh' }, { duration: 800 })
           curtain.style.height = '100vh'
           curtain.style.top = '100vh'
          // curtain.style.position = 'absolute'
           curtain.style.zIndex = '5'
         } else {
           curtain.style.height = '0px'
           curtain.style.top = '0'
           curtain.style.position = 'absolute'
           curtain.style.zIndex = '5'
         }
       }
      // window.Velocity(el, { zIndex: '-1' }, { duration: 10 })
      // slide.style.height = '100vh'
      // slide.style.position = 'absolute'
      // slide.style.zIndex = '0'
     } else if (pageName === 'Profile') {
      // if (windowWidth > 1024) {
       instragramView.style.opacity = 0
       var previewImage = document.getElementById('previewImages')
       previewImage.style.position = 'absolute'
      /* } else {
      } */
     } else if (pageName === 'Service') {
       servicesWrap[0].style.position = 'absolute'
       servicesWrap[0].style.width = '100vw'
       servicesWrap[0].style.top = 0
       servicesWrap[0].style.left = 0
       servicesWrap[0].style.zIndex = 1
       curtain.style.display = 'none'
     } else {
       curtain.style.height = '0px'
       curtain.style.top = '0'
       curtain.style.position = 'absolute'
       curtain.style.zIndex = '5'
     }
   },
   leave (el, location, done) {
     // console.log('leave!')
     var windowWidth = screen.width
    // console.log(windowWidth)
     var pageName = location
     var curtain = document.getElementById('curtain')
     var profile = document.getElementsByClassName('profile')
     var slide = document.getElementsByClassName('VueCarousel-slide-active')
     var menuBar = document.getElementById('menuBar')
     var servicesWrap = document.getElementsByClassName('services')
     // var service = document.getElementById('service')
     // service = service.parentNode
     slide = slide[0]

     if (pageName === 'theFlock') {
       document.documentElement.style.overflowX = 'hidden'
       profile = profile[0]
       if (profile) {
         if (windowWidth > 1024) {
          /* setTimeout(function () {
            el.style.backgroundColor = 'transparent'
          }, 800) */
           window.Velocity(menuBar, { opacity: '0' }, { duration: 500 })
          // window.Velocity(el, { left: '48.5vw' }, { duration: 900, complete: done })
           window.Velocity(el, { left: '50vw' }, { duration: 768,
             complete: function () {
               window.Velocity(el, { left: '100vw' }, { duration: 760, delay: 900, easing: [ 0.42, 0, 1, 1 ], complete: done })
             }
           })
          // --> window.Velocity(el, { opacity: '0' }, { duration: 1200, complete: done })
         } else {
           window.Velocity(document.body, 'scroll', { offset: '0' }, { duration: 6000 })
           window.Velocity(menuBar, { opacity: '0' }, { duration: 800 })
           setTimeout(function () {
             el.style.backgroundColor = 'transparent'
           }, 300)
           window.Velocity(el, { left: '99vw' }, { duration: 900 })
           window.Velocity(el, { opacity: '0' }, { duration: 900, complete: done })
         }
       } else {
         window.Velocity(curtain, { height: '100vh' }, { duration: 800, delay: 200, complete: done })
       }
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       window.Velocity(curtain, { height: '100vh' }, { duration: 800, delay: 200, complete: done })
     } else if (pageName === 'Home') {
       var nutshellInner = document.getElementById('casestudiesInner')
       if (nutshellInner) {
         if (windowWidth > 768) {
           window.Velocity(nutshellInner, { opacity: 0 }, { duration: 500 })
           window.Velocity(el, { marginTop: '100vh' }, { duration: 500, delay: 500 })
           window.Velocity(curtain, { height: '100vh' }, { duration: 800, delay: 200, complete: done })
         } else {
           window.Velocity(nutshellInner, { opacity: 0 }, { duration: 500 })
           // window.Velocity(curtain, { height: '100vh' }, { duration: 800, delay: 200, complete: done })
         }
       } else {
         window.Velocity(curtain, { height: '100vh' }, { duration: 800, delay: 200, complete: done })
       }
     } else if (pageName === 'casestudies') {
       /* if (slide) {
         window.Velocity(slide, { height: '100vh' }, { duration: 800 })
       } */
       window.Velocity(curtain, { height: '100vh' }, { duration: 800, complete: done })
     } else if (pageName === 'Project') {
       var fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 4')
         if (slide) {
           window.Velocity(slide, { height: '100vh' }, { duration: 10, complete: done })
         } else {
           var firstSlide = document.getElementById('slide0')
           window.Velocity(firstSlide, { height: '100vh' }, { duration: 10, complete: done })
         }
       } else {
         var projectFooter = document.getElementById('casestudyFooter')
         if (projectFooter) {
           window.Velocity(curtain, { top: 0 }, { duration: 800,
             complete: function () {
               window.scrollTo(0, 0)
               done()
             }
           })
         } else {
           window.Velocity(curtain, { height: '100vh' }, { duration: 500, complete: done })
         }
       }
     } else if (pageName === 'Work') {
       fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 4')
         if (slide) {
           window.Velocity(slide, { height: '100vh' }, { duration: 10, complete: done })
         } else {
           firstSlide = document.getElementById('slide0')
           window.Velocity(firstSlide, { height: '100vh' }, { duration: 10, complete: done })
         }
       } else {
         projectFooter = document.getElementById('casestudyFooter')
         if (projectFooter) {
           window.Velocity(curtain, { top: 0 }, { duration: 800,
             complete: function () {
               window.scrollTo(0, 0)
               done()
             }
           })
         } else {
           window.Velocity(curtain, { height: '100vh' }, { duration: 500, complete: done })
         }
       }
     } else if (pageName === 'Profile') {
       document.documentElement.style.overflowX = 'hidden'
       if (windowWidth > 1024) {
        // window.Velocity(previewImage, { right: '0px' }, { duration: 760 })
         window.Velocity(el, { right: '49vw' }, { duration: 760 })
         window.Velocity(el, { opacity: 0 }, { duration: 500, complete: done })
        /* window.Velocity(previewImage, { right: '50%', opacity: '0' }, {
          duration: 800,
          delay: 800,
          easing: [ 0.215, 0.61, 0.355, 1 ],
          complete: done }) */
       } else {
         window.Velocity(el, { right: '100vw' }, { duration: 760 })
         window.Velocity(el, { opacity: 0 }, { duration: 800, complete: done })
       }
     } else if (pageName === 'Service') {
       window.Velocity(servicesWrap[0], { left: '-100vw' }, { duration: 760 })
     } else {
       window.Velocity(curtain, { height: '100vh' }, { duration: 500, complete: done })
     }
   },
   afterLeave (el, location, done) {
     // console.log('after leave')
     var windowWidth = screen.width
     // var windowWidth = screen.width
     var pageName = location
     var curtain = document.getElementById('curtain')
     var flock = document.getElementsByClassName('flock')
     var menuBar = document.getElementById('menuBar')
     var profile = document.getElementsByClassName('profile')

     if (pageName === 'theFlock') {
       flock = flock[0]
       if (profile[0]) {
         menuBar.style.position = 'relative'
         window.Velocity(menuBar, { opacity: 0 }, { duration: 3000 })
         el.style.backgroundColor = '#EFF0F1'
        // window.Velocity(profile[0], { left: '100vw' }, { duration: 800 })
       }
       if (flock) {
         flock.style.position = 'relative'
         flock.style.zIndex = '0'
         flock.style.height = 'auto'
       }
       window.Velocity(curtain, { top: '200vh' }, { duration: 1200,
         delay: 600,
         complete: function () {
           document.getElementById('curtain').style.top = '0'
           document.getElementById('curtain').style.height = '0px'
         }
       })
     } else if (pageName === 'Service') {
       console.log('finished')
     } else if (pageName === 'ourservices' || pageName === 'packages') {
       window.Velocity(document.body, 'scroll', { offset: 0 }, { duration: 50 })
       window.Velocity(curtain, { top: '200vh' }, { duration: 800,
         delay: 600,
         complete: function () {
           document.getElementById('curtain').style.top = '0'
           document.getElementById('curtain').style.height = '0px'
         }
       })
     } else if (pageName === 'casestudies') {
       window.Velocity(curtain, { top: '200vh' }, { duration: 800,
         delay: 600,
         complete: function () {
           document.getElementById('curtain').style.top = '0'
           document.getElementById('curtain').style.height = '0px'
         }
       })
     } else if (pageName === 'Home') {
       // console.log(windowWidth)
       if (windowWidth > 765) {
         window.Velocity(curtain, { top: '200vh' }, { duration: 800,
           delay: 600,
           complete: function () {
             document.getElementById('curtain').style.top = '0'
             document.getElementById('curtain').style.height = '0px'
             // document.getElementById('curtain').style.position = 'fixed'
           }
         })
       }
     } else if (pageName === 'Project') {
       var fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 5')
       } else {
         window.Velocity(curtain, { top: '-100vh' }, { duration: 800,
           delay: 200,
           complete: function () {
             document.getElementById('curtain').style.top = '100vh'
             document.getElementById('curtain').style.height = '0px'
             document.getElementById('curtain').style.position = 'fixed'
           }
         })
       }
     } else if (pageName === 'Work') {
       fromHome = document.getElementById('innerNutshell')
       if (fromHome) {
         // console.log('coming from home 5')
       } else {
         window.Velocity(curtain, { top: '-100vh' }, { duration: 800,
           delay: 200,
           complete: function () {
             document.getElementById('curtain').style.top = '100vh'
             document.getElementById('curtain').style.height = '0px'
             document.getElementById('curtain').style.position = 'fixed'
           }
         })
       }
     } else {
       window.Velocity(curtain, { top: '200vh' }, { duration: 800,
         delay: 200,
         complete: function () {
           document.getElementById('curtain').style.top = '0'
           document.getElementById('curtain').style.height = '0px'
           document.getElementById('curtain').style.position = 'fixed'
         }
       })
     }
   }
 }



// WEBPACK FOOTER //
// ./src/assets/js/pageTransitions.js